import BatchTemplateRequestModal from "@areas/trade-accounts/flows/BatchTemplateRequestModal";
import PaymentRequestDetails from "@areas/payments/displays/PaymentRequestDetails";
import PlanDetailModal from "@areas/calendar/displays/PlanDetailModal";
import SendEmailPreviewModal from "../SmartNoteModal/SendEmailPreviewModal";
import CancelActionConfirmModal from "../SmartNoteModal/CancelActionConfirmModal";
import { stepToRequestConfig } from "../SmartNoteModal/actionAmendments";

// The stack of secondary modals/drawers a suggestion can open (edit-then-accept, read-only step
// preview, document email preview, cancellation confirm, and the payment-request drawer / plan
// modal opened from the activity feed). All state lives on the shared controller, so this is the
// same set V1 renders — kept in one place so both layouts behave identically.
export default function SmartNoteActionModals({ controller: c }) {
  return (
    <>
      <BatchTemplateRequestModal
        isOpen={!!c.editTarget}
        onClose={c.closeEdit}
        customerData={c.editTarget && c.requestCustomer ? [c.requestCustomer] : []}
        requestConfig={c.editStep ? stepToRequestConfig(c.editStep.payload) : null}
        skipTemplateSelect
        onAcceptAction={c.handleAcceptEdited}
        acceptPending={c.decideAction.isPending}
      />

      <BatchTemplateRequestModal
        readOnly
        isOpen={!!c.preview}
        onClose={() => c.setPreview(null)}
        customerData={c.preview && c.requestCustomer ? [c.requestCustomer] : []}
        requestConfig={c.preview ? stepToRequestConfig(c.preview.step.payload) : null}
        readOnlyTitle={
          c.preview?.instalment && c.preview.instalment.total > 1
            ? `Instalment ${c.preview.instalment.number} of ${c.preview.instalment.total}`
            : undefined
        }
        skipTemplateSelect
      />

      <SendEmailPreviewModal
        isOpen={!!c.editDocsTarget}
        suggestion={c.editDocsTarget?.suggestion}
        customer={c.analysedCustomer}
        onClose={c.closeDocsEdit}
        onSend={c.handleAcceptDocsEdited}
        sending={c.decideAction.isPending}
      />

      <CancelActionConfirmModal
        isOpen={!!c.cancelTarget}
        params={c.cancelTarget?.suggestion?.params}
        customerName={c.analysedCustomer?.name}
        onConfirm={c.performCancellation}
        onClose={() => c.setCancelTarget(null)}
        submitting={c.cancelAction.isPending}
      />

      <PaymentRequestDetails
        paymentRequestId={c.paymentRequestId}
        elevated
        onChange={() => {}}
        onViewPlan={(actionId) => {
          c.setPaymentRequestId(null);
          c.setPlanActionId(actionId);
        }}
        onClose={() => c.setPaymentRequestId(null)}
        compactActions
      />

      <PlanDetailModal
        actionId={c.planActionId}
        isOpen={!!c.planActionId}
        elevated
        onClose={() => c.setPlanActionId(null)}
        onOpenPaymentRequest={c.openPaymentRequestFromPlan}
      />
    </>
  );
}
